export const ShareSpaceService = Symbol.for('ShareSpaceService');
